import React, { useEffect, useState } from 'react';
import T from 'i18n-react';
import { PRODUCT_TESTING_LANG_PATH } from 'shared/path';
import { setLanguageLocale } from 'util/icwUtility';
import { apiGetFileDetails } from 'api';
import classes from './PublicViewFile.module.scss';

setLanguageLocale(T, [PRODUCT_TESTING_LANG_PATH]);

const PublicViewFile = ({ match }) => {
  const [fileSrc, setFileSrc] = useState('');
  const [loading, setLoading] = useState(false);
  const filePath = match?.params?.filePath;
  const fileName = match?.params?.fileName;

  const loadFileDetails = async (tPath, tName) => {
    setLoading(true);
    try {
      const res = await apiGetFileDetails(tPath, tName);
      setFileSrc(res?.data?.data?.url || '');
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setFileSrc('');
    }
  }

  useEffect(() => {
    if (!!filePath && !!fileName) {
      loadFileDetails(filePath, fileName);
    }
  }, [filePath, fileName])
  

  return (
    <div className={classes.wrapper}>
      <iframe src={fileSrc} frameborder="0"></iframe>
    </div>
  );
};

export default PublicViewFile;
